import styled, { css } from 'styled-components';

interface WrapperProps {
  isExpanded?: boolean;
}

export const Wrapper = styled.div`
  display: flex;
  padding: 8px 12px;
  border-radius: 8px;
  background: ${({ theme }) => theme.palette.bg700};
  ${({ theme }) => theme.typography('$body_02')};
`;

export const Badge = styled.div`
  display: flex;
  flex: 0 0 24px;
  margin-right: 8px;
  color: ${({ theme }) => theme.palette.brand500};
  ${({ theme }) => theme.typography('$body_03')};
`;

export const Contents = styled.div<WrapperProps>`
  width: 100%;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  text-overflow: ellipsis;

  ${({ isExpanded }) =>
    isExpanded &&
    css`
      display: block;
      white-space: pre-wrap;
    `}
`;

export const IconWrapper = styled.div<WrapperProps>`
  ${({ isExpanded }) =>
    isExpanded &&
    css`
      position: relative;
      top: -6px;
      transform-origin: center;
      transform: rotate(180deg);
    `}
`;

export const ButtonExpand = styled.button<WrapperProps>`
  flex: 0 0 20px;
  width: 20px;
  height: 20px;
`;
